import './Contact.css'

const Contact = () => {
  return (
    <>
      <h1>Contact Me!</h1>
      <p>Please reach out if you'd like to work with me!</p>
      <div className='contact'>
        <a href="mailto: justin.pastine@gmail.com">Send Email</a>
      
        <a href="https://github.com/jpastine">My GitHub</a>
        <a href="https://www.linkedin.com/in/justin-pastine/">My LinkedIn Profile</a>
      </div>

    </>
  )
}

export default Contact